'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherCalendar, FeatherClock } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, TextArea, TextField } from '@/shared/components/ui';
import { formatDataPrazoAbreviada } from '@/shared/formatters';
import type { TrialTenant } from '../types';
import { calcularDiasPeriodo, dataAtualISO, formatarDataCurta, isDataFutura, toLocalYMD } from '../utils/trialDateUtils';
interface ExtenderTrialModalProps {
  isOpen: boolean;
  trial: TrialTenant | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (novaDataExpiracao: string, motivo: string) => void;
}
export function ExtenderTrialModal(t0) {
  const $ = _c(70);
  const {
    isOpen,
    trial,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [novaData, setNovaData] = useState("");
  const [motivo, setMotivo] = useState("");
  const [erroData, setErroData] = useState(null);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setNovaData("");
        setMotivo("");
        setErroData(null);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!trial) {
    return null;
  }
  const dataExpiracaoAtualISO = toLocalYMD(trial.dataExpiracao);
  let t3;
  if ($[3] !== motivo) {
    t3 = motivo.trim();
    $[3] = motivo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const motivoPreenchido = t3.length > 0;
  let t4;
  if ($[5] !== dataExpiracaoAtualISO || $[6] !== novaData) {
    t4 = novaData !== "" && novaData > dataExpiracaoAtualISO && isDataFutura(novaData);
    $[5] = dataExpiracaoAtualISO;
    $[6] = novaData;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const dataValida = t4;
  const podeConfirmar = dataValida && motivoPreenchido && !saving;
  let t5;
  if ($[8] !== dataValida || $[9] !== novaData || $[10] !== trial.dataInicio) {
    t5 = dataValida && trial.dataInicio ? calcularDiasPeriodo(toLocalYMD(trial.dataInicio), novaData) : 0;
    $[8] = dataValida;
    $[9] = novaData;
    $[10] = trial.dataInicio;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const periodoNovo = t5;
  let t6;
  if ($[12] !== dataExpiracaoAtualISO) {
    t6 = value => {
      setNovaData(value);
      if (!value) {
        setErroData(null);
        return;
      }
      if (value <= dataExpiracaoAtualISO) {
        setErroData("A nova data deve ser posterior \xE0 data de expira\xE7\xE3o atual");
      } else {
        if (!isDataFutura(value)) {
          setErroData("A nova data deve ser futura");
        } else {
          setErroData(null);
        }
      }
    };
    $[12] = dataExpiracaoAtualISO;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleNovaDataChange = t6;
  let t7;
  if ($[14] !== motivo || $[15] !== novaData || $[16] !== onConfirm || $[17] !== podeConfirmar) {
    t7 = () => {
      if (!podeConfirmar) {
        return;
      }
      const dataIso = new Date(`${novaData}T23:59:59-03:00`).toISOString();
      onConfirm(dataIso, motivo.trim());
    };
    $[14] = motivo;
    $[15] = novaData;
    $[16] = onConfirm;
    $[17] = podeConfirmar;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleConfirm = t7;
  let t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="bg-warning-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherClock className="text-warning-600 h-5 w-5" /></div>;
    t9 = <h2 className="text-body-bold font-body-bold text-default-font">Estender trial</h2>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[21] !== trial.tenantNome) {
    t10 = <div className="flex items-start gap-3">{t8}<div>{t9}<p className="text-caption font-caption text-subtext-color mt-1">{trial.tenantNome}</p></div></div>;
    $[21] = trial.tenantNome;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherCalendar className="h-4 w-4 text-neutral-400" />;
    t12 = <span className="text-neutral-600">Expira atualmente em</span>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  let t13;
  if ($[25] !== trial.dataExpiracao) {
    t13 = formatarDataCurta(trial.dataExpiracao);
    $[25] = trial.dataExpiracao;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <div className="flex items-center gap-3 rounded-[8px] bg-neutral-50 px-4 py-3 text-sm">{t11}{t12}<span className="ml-auto font-semibold text-neutral-900">{t13}</span></div>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = !!erroData;
  const t16 = erroData ?? undefined;
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = dataAtualISO();
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== handleNovaDataChange) {
    t18 = event => handleNovaDataChange(event.target.value);
    $[30] = handleNovaDataChange;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== novaData || $[33] !== t18) {
    t19 = <TextField.Input type="date" value={novaData} min={t17} onChange={t18} />;
    $[32] = novaData;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t19) {
    t20 = <div className="flex flex-col gap-1.5"><TextField label={"Nova data de expira\xE7\xE3o *"} error={t15} helpText={t16}>{t19}</TextField></div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== dataValida || $[40] !== novaData || $[41] !== periodoNovo || $[42] !== trial.dataExpiracao) {
    t21 = dataValida && <div className="border-warning-200 bg-warning-50 flex items-center justify-between rounded-[8px] border px-4 py-3 text-sm"><div className="flex items-center gap-2"><span className="text-warning-700 font-medium">{formatarDataCurta(trial.dataExpiracao)}</span><FeatherArrowRight className="text-warning-700 h-3.5 w-3.5" /><span className="text-warning-700 font-semibold">{formatDataPrazoAbreviada(novaData)}</span></div><span className="text-warning-800 text-xs font-medium">Total: {periodoNovo} dias</span></div>;
    $[39] = dataValida;
    $[40] = novaData;
    $[41] = periodoNovo;
    $[42] = trial.dataExpiracao;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <label className="text-sm font-medium text-neutral-700">Motivo da extensão *</label>;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = event_0 => setMotivo(event_0.target.value);
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== motivo) {
    t24 = <div className="flex flex-col gap-1.5">{t22}<TextArea><TextArea.Input placeholder={"Descreva o motivo da extens\xE3o para registro de auditoria..."} value={motivo} onChange={t23} rows={3} /></TextArea></div>;
    $[46] = motivo;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex items-start gap-2 rounded-[8px] bg-neutral-50 px-3 py-2 text-xs text-neutral-600">Esta ação será registrada no histórico com seu usuário, a data atual e o motivo informado.</div>;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== onClose || $[50] !== saving) {
    t26 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[49] = onClose;
    $[50] = saving;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  const t27 = !podeConfirmar;
  let t28;
  if ($[52] !== handleConfirm || $[53] !== saving || $[54] !== t27) {
    t28 = <Button variant="brand-primary" size="medium" onClick={handleConfirm} loading={saving} disabled={t27}>Confirmar extensão</Button>;
    $[52] = handleConfirm;
    $[53] = saving;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t26 || $[57] !== t28) {
    t29 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t26}{t28}</div>;
    $[56] = t26;
    $[57] = t28;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t10 || $[60] !== t14 || $[61] !== t20 || $[62] !== t21 || $[63] !== t24 || $[64] !== t29) {
    t30 = <Dialog.Content className="max-w-md"><div className="flex w-full flex-col gap-5 p-6">{t10}{t14}{t20}{t21}{t24}{t25}{t29}</div></Dialog.Content>;
    $[59] = t10;
    $[60] = t14;
    $[61] = t20;
    $[62] = t21;
    $[63] = t24;
    $[64] = t29;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== isOpen || $[67] !== onClose || $[68] !== t30) {
    t31 = <Dialog open={isOpen} onOpenChange={onClose}>{t30}</Dialog>;
    $[66] = isOpen;
    $[67] = onClose;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  return t31;
}